'use strict';

function MapMarkerAbstract() {
    this.marker = null;
}
